<template>
  <ZLoader v-if="flagLoading" />
  <div class="w-full h-screen relative bg-[#b7cef2] overflow-hidden" v-else>
    <div class="absolute inset-0 flex flex-col items-center justify-start">
      <img
        class="w-[500px] h-[210px] mt-[50px]"
        src="https://upload.wikimedia.org/wikipedia/commons/2/2b/Ziply_Fiber_logo.svg"
        alt="Logo"
        style="z-index: 3"
      />

      <div
        class="w-[500px] mt-10 bg-white rounded-xl shadow-lg p-10 flex flex-col gap-5"
        style="z-index: 4"
      >
        <div class="text-[#4d586c] text-2xl font-bold">Login</div>
        <div class="flex flex-col gap-5">
          <div class="flex flex-col gap-1.5">
            <label class="text-[#4d586c] text-base font-medium">Email</label>
            <input
              v-model="email"
              type="email"
              placeholder="mail@example.com"
              :class="{
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-red-400 border-solid':
                  !isEmailValid(email),
                'w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid':
                  isEmailValid(email),
              }"
            />
          </div>
          <div class="flex flex-col gap-1.5 relative">
            <label class="text-[#4d586c] text-base font-medium">Password</label>
            <div class="relative w-full">
              <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="********"
                class="w-full px-3 py-2 bg-white border border-[#dfe3f0] rounded-lg pr-10"
              />

              <button
                type="button"
                @click="toggleShowPassword"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-blue_primary text-sm"
              >
                {{ showPassword ? "Hide" : "Show" }}
              </button>
            </div>
          </div>

          <div class="text-xs text-[#475466]">
            Forgot Password?
            <span class="text-[#1762d4] cursor-pointer" @click="forgotPassword">
              Reset
            </span>
          </div>
        </div>
        <button
          @click="submit"
          class="h-11 px-6 py-2.5 bg-[#1762d4] rounded-lg text-white font-semibold"
        >
          Login
        </button>
        <button
          @click="register"
          class="h-11 px-6 py-2.5 bg-blue_primary rounded-lg text-white font-semibold"
        >
          Register User
        </button>
        <span class="text-red-500" v-if="flagLogin">
          Something went wrong, try again!
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import { ref } from "vue";
import ZLoader from "./ZLoader.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  components: { ZLoader },
  setup() {
    const store = useStore();
    const router = useRouter();
    const email = ref("");
    const password = ref("");
    const flagLoading = ref(false);
    const flagLogin = ref(false);
    const showPassword = ref(false);

    const isEmailValid = (email) => /\S+@\S+\.\S+/.test(email);

    const submit = async () => {
      const data = {
        email: email.value,
        password: password.value,
      };

      try {
        flagLoading.value = true;
        flagLogin.value = false;
        await store.dispatch("loginUser", data).then((logged) => {
          
          if (logged.ok) {
            sessionStorage.setItem("selectedButton", "dashboard");
            sessionStorage.setItem(
              "userData",
              JSON.stringify({
                cris_id: logged.user.cris_id,
                name: logged.user.name,
                last_name: logged.user.last_name,
                id_user: logged.user.id_user,
                email: logged.user.email,
              })
            );

            setTimeout(() => {
              flagLoading.value = false;
              router.push({ name: "Dashboard" });
            }, "3000");
          } else {
            flagLogin.value = true;
            flagLoading.value = false;
          }
        });
      } catch (error) {
        console.error("Error during login:", error);
        flagLogin.value = true;
        flagLoading.value = false;
      }
    };

    const toggleShowPassword = () => {
      showPassword.value = !showPassword.value;
    };
    function register() {
      router.push({ name: "RegisterUser" });
    }

    function forgotPassword() {
      router.push({ name: "RecoverPassword" });
    }

    function goToRegister() {
      router.push({ name: "RegisterUser" });
    }

    return {
      email,
      password,
      isEmailValid,
      submit,
      flagLoading,
      forgotPassword,
      goToRegister,
      flagLogin,
      register,
      toggleShowPassword,
      showPassword,
    };
  },
};
</script>

<style scoped>
</style>